module.exports = __webpack_public_path__ + "img/ok.24b32d34.png";